import { useIntl } from 'react-intl';
import { TranslationKey } from './types';

/**
 * Custom hook to provide a simpler API for translations.
 * Returns a `translation` function that acts like `useTranslations` in next-intl.
 */
export function useClientTranslation() {
  const intl = useIntl();

  const translation = (id: TranslationKey, values?: Record<string, any>) => {
    return intl.formatMessage({ id }, values);
  };

  return translation;
}
